/* @ngInject */
function RepositoryDragAndDropController ($scope, $rootScope, $timeout, $translate, $attrs, ToastService, UploadService) {
  $scope.disableAnimation = false
  $scope.dragAndDropEvent = ''
  const dropZone = $attrs.$$element.find('#dropZone')[0]
  const mainContent = $scope.modalState ? $scope.mainContent.children[0] : $scope.mainContent.children[1]
  const api = {
    _setDropZone,
    _checkDragEvent,
    _onDrop,
    _handleFileDrop
  }

  this.getApi = () => api

  function activate () {
    api._setDropZone()
  }

  activate()

  function _setDropZone () {
    mainContent.addEventListener('dragover', api._checkDragEvent, false)
    mainContent.addEventListener('dragleave', api._checkDragEvent, false)
    dropZone.addEventListener('drop', api._onDrop, false)
  }

  function _checkDragEvent (event) {
    event.stopPropagation()
    event.preventDefault()

    if (event.type === 'dragleave' && event.currentTarget?.contains(event.relatedTarget)) {
      return
    }

    $timeout(() => {
      if (event.type === 'dragover') {
        $scope.disableAnimation = true
        $scope.dragAndDropEvent = ''
        $scope.$emit('repository.set-drag-and-drop-blur', true)
      }

      if (event.type === 'dragleave' || event.type === 'drop') {
        $scope.disableAnimation = false
        $scope.dragAndDropEvent = event.type
        $scope.$emit('repository.set-drag-and-drop-blur', false)
      }
    })
  }

  function _onDrop (event) {
    api._checkDragEvent(event)
    const filesArray = Array.from(event.dataTransfer.files)
    api._handleFileDrop(filesArray)
  }

  $scope.$on('$destroy', function () {
    mainContent.removeEventListener('dragover', api._checkDragEvent)
    mainContent.removeEventListener('dragleave', api._checkDragEvent)
    dropZone.removeEventListener('drop', api._onDrop)
  })

  function _handleFileDrop (files) {
    $rootScope.$emit('upload-tab.upload-new-assets', files, { folderId: $scope.folder?.id, isOrganized: Boolean($scope.isOrganized) })
  }
}

export { RepositoryDragAndDropController }
